import { Button, Modal, notification } from "antd";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import axios from "../../../../Services/axiosCommon";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Dasboard from "../../../../Components/Icons/Dasboard";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import NuDate from "../../../../Components/Utils/NuDate";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { NuInput, NuLabel, NuMobileNumber, NuSelect, NuTime } from "../../../../Components/Utils/Input";
import CustomImgUpload from "../../../../Components/Utils/CustomImgUpload";
import MultiSelect from "../../../../Components/Utils/MultiSelect";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import axiosInstance from "../../../../Services/axiosCommon";

function EditRentalManpower({EditNew,open, getData=()=>{}, onCancel,id ,data}) {
  const [api, contextHolder] = notification.useNotification();
  // const [positionList, setpostionList] = useState([]);
  const [projectList, setProjectList] = useState([]);
   const [createNew, setCreateNew] = useState({
   
    job_role:"",
    type:"",
    working_hours:"",
    amount_per_hour:""
  });

 
  useEffect(() => {
    data &&
      setCreateNew({
        job_role: data?.job_role,
        type: data?.type,
        working_hours: data?.working_hours,
        amount_per_hour: data?.amount_per_hour,

             });
    // memberPosition();

    console.log("leo ",data);
    
    getAllProject();
  }, [data]);

  
  function getAllProject() {
    axios.get(`/Team/getUserProjectId`).then((res) => {
      let allProject = res.data?.data;
      let finalData = [];
      res.data?.data &&
        allProject.forEach((i) => {
          let x = {
            value: i.ProjectId,
            label: i.ProjectName,
          };
          finalData.push(x);
        });
      setProjectList(finalData);
    });
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
     
    }),
    
    onSubmit: async (value, { resetForm }) => {
      // const withBranchId = {
      //   ...value,
      //   branch: officeId
      // }
      axiosInstance.put(`/manpower-role/${data?.id}`,value)
      
      .then((res) => {
          console.log("res",res.data.status);
          if (res.data.status) {
            api.success({
              message: `Activity Update successfully`,
              description: res?.data?.msg || "Added In The Activity",
              placement: "bottomRight",
            });
            getData(id);
            resetForm();
            onCancel();
          } else {
            api.error({
              message: `Activity Upadate failed`,
              description: res?.data?.msg || "Network error",
              placement: "bottomRight",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          
          api.error({
            message: `failed`,
            description: err?.data?.msg || "Sever error (or) Network error",
            placement: "bottomRight",
          });
        });
    },
  });

  return (
      <>
        {contextHolder}
        <Modal
          open={open}
          title={"Edit Rental Manpower"}
          width={"50%"}
          className="my-modal"
          centered
          onCancel={onCancel}
          footer={[]}
        >
        <form onSubmit={formik.handleSubmit} >
         <div className=" w-full flex flex-wrap">
         <NuInput
              label="Job Role"
              placeholder="Job Role"
              formik={formik}
              name="job_role"
              width="w-full md:w-1/2"
              isRequired={true}
          />
          <FormikSelectTwo
              label="Type"
              Options={[
                {value: 0, label:"Own"},
                {value: 1, label:"Rental"},
              ]}
              formik={formik}
              placeholder="Choose"
              name="type"
              width="w-full md:w-1/2"
          />
            <NuInput
                        type="number"
              label="Working Hours"
              placeholder="Working Hours"
              formik={formik}
              name="working_hours"
              width="w-full md:w-1/2"
             
          />
          
                        <NuInput
                        type="number"
              label="Amount Per Hour"
              placeholder="Amount Per Hour"
              formik={formik}
              name="amount_per_hour"
              width="w-full md:w-1/2"
             
          />    
               
    <button
                  type="submit"
                 
                  className="w-11/12 bg-textColor-main py-3 rounded-lg cursor-pointer text-sm outline-none border-none hover:text-white focus:text-white text-white  mx-auto"
                >
                  Update 
                </button>
              </div>
         
        </form>
        </Modal>
        </>
  )
}
export default EditRentalManpower;
